<div class="md:tw-max-w-[500px] tw-max-w-[300px]">
<!-- title -->
<app-modal-title [title]="title|translate" [isShowClose]="true" (isCloseModal)="onClose()"></app-modal-title>

  <div *ngIf="model?.description" mat-dialog-content class="dialog-content">

    <p class="tw-pb-5 tw-text-center tw-font-bold tw-text-primary-500 dark:tw-text-primary-400 tw-text-xl">
      {{model?.title}}
    </p>

    <p class="tw-text-gray-700 dark:tw-text-gray-300 tw-text-base tw-leading-7">{{model?.description}}</p>

  </div>
  <div *ngIf="!model?.description">
    <p class="dark:tw-text-primary-300 tw-mt-10 tw-px-11 tw-text-center tw-font-bold tw-pb-5 tw-text-primary-600 tw-text-xl">
      {{'messages.eventTitle'|translate}}
    </p>
  </div>
</div>